import MeetingIcon from './component.jsx'
export default MeetingIcon
